module.exports = __webpack_public_path__ + "static/media/task.dcca33cf.svg";